import { render, staticRenderFns } from "./PopupAddDocument.vue?vue&type=template&id=827389ee"
import script from "./PopupAddDocument.vue?vue&type=script&lang=ts"
export * from "./PopupAddDocument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports